<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2021-01-28 10:25:35
-->
<template>
  <div>
    <div class="not-found-page__div--container">
      <div class="head404"></div>
      <div class="txtbg404">
        <div class="txtbox">
          <p>对不起，您请求的页面不存在、或已被删除、或暂时不可用</p>
          <p class="paddingbox">请点击以下链接继续浏览网页</p>
          <p>》<a
              style="cursor:pointer"
              @click="goBack"
            >返回上一页面</a></p>
          <p>》<a @click="goHome">返回网站首页</a></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods:{
    goBack(){
      this.$router.go(-1);
    },
    goHome(){
      this.$router.push({
        name:'home'
      })
    }
  }
};
</script>

<style>
.not-found-page__div--container {
  background-color: #494949;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
}

.head404 {
  width: 580px;
  height: 234px;
  margin: 50px auto 0 auto;
  background: url(https://www.daixiaorui.com/Public/images/head404.png)
    no-repeat;
}

.txtbg404 {
  width: 499px;
  height: 169px;
  margin: 10px auto 0 auto;
  background: url(https://www.daixiaorui.com/Public/images/txtbg404.png)
    no-repeat;
}

.txtbg404 .txtbox {
  width: 390px;
  position: relative;
  top: 30px;
  left: 60px;
  color: #eee;
  font-size: 13px;
}

.txtbg404 .txtbox p {
  margin: 5px 0;
  line-height: 18px;
}

.txtbg404 .txtbox .paddingbox {
  padding-top: 15px;
}

.txtbg404 .txtbox p a {
  color: #eee;
  text-decoration: none;
}

.txtbg404 .txtbox p a:hover {
  color: #fc9d1d;
  text-decoration: underline;
}

html,
body {
  width: 100%;
  height: 100%;
}
</style>
